export default __webpack_public_path__ + "static/photo-28-bc1dc0b28198189225dfc0b43d5a4b6f.jpg";